export const TEMPLATES_LIMIT = 25;
